import classNames from "classnames";
import styles from "./CreditOffersGroup.module.scss";
import { CreditIllustration } from "@/types/cobeTypes";
import { CreditOffersCardContent } from "./CreditOffersCardContent";

type Props = {
  creditOfferGroup: CreditIllustration[];
  type: "IFC" | "IBC" | "DEFERRED_IBC" | "BNPL";
};

export interface CreditOfferCardProps {
  creditOffer: CreditIllustration;
  index: number;
}

export const CreditOffersGroup = ({ creditOfferGroup, type }: Props) => {
  const isList = creditOfferGroup.length > 1;

  const CreditOfferCard = ({ creditOffer, index }: CreditOfferCardProps) => {
    const {
      financialProductType,
      creditRate,
      repaymentAmount,
      creditTerm,
      creditAmount,
      totalRepaymentAmount,
      holidayPeriod,
      repaymentCount,
      creditProvider,
      creditType,
      creditOfferingId,
    } = creditOffer;

    return (
      <div
        className={styles.creditOfferCard}
        data-testid={`credit-offer-card-${financialProductType}`}
      >
        <CreditOffersCardContent
          isList={isList}
          financialProductType={financialProductType}
          creditRate={creditRate}
          creditTerm={creditTerm}
          creditAmount={creditAmount}
          holidayPeriod={holidayPeriod}
          totalRepaymentAmount={totalRepaymentAmount}
          repaymentAmount={repaymentAmount}
          repaymentCount={repaymentCount}
          creditOfferingId={creditOfferingId}
          creditProvider={creditProvider}
          creditType={creditType}
          index={index}
        />
      </div>
    );
  };

  const isListClass = isList ? "multiOffer" : "soloOffer";

  return (
    <div
      data-testid={`credit-offer-group-${type}`}
      className={classNames(
        styles.creditOffersGroup,
        styles[`creditOffersGroup__${type}`],
        styles[`creditOffersGroup__${isListClass}`],
      )}
    >
      {isList && (
        <p
          data-testid="credit-offer-group-title"
          className={classNames(
            styles.creditOfferCard__title,
            styles.creditOffersGroup__multiOffer__title,
          )}
        >
          <span>{creditOfferGroup[0]?.creditRate.display} APR</span>
        </p>
      )}
      {creditOfferGroup.map((offer, index) => (
        <CreditOfferCard key={index} creditOffer={offer} index={index} />
      ))}
    </div>
  );
};
